import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/bulb.tsx
var Bulb = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M8.86131 17.1154V16.4825C8.86131 16.1141 8.65239 15.7821 8.34139 15.5893C8.13216 15.4596 7.9302 15.3191 7.73627 15.1686C6.07234 13.877 5 11.8474 5 9.56496C5 5.66309 8.13401 2.5 12 2.5C15.866 2.5 19 5.66309 19 9.56496C19 11.8474 17.9277 13.877 16.2637 15.1686C16.0698 15.3191 15.8678 15.4596 15.6586 15.5893C15.3476 15.7821 15.1387 16.1141 15.1387 16.4825V17.1154M8.86131 17.1154V18.3322C8.86131 20.0817 10.2665 21.5 12 21.5C13.7334 21.5 15.1387 20.0817 15.1387 18.3322V17.1154M8.86131 17.1154H15.1387",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "square"
	}) : /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", {
		d: "M4.5 9.61989C4.5 5.41154 7.85786 2 12 2C16.1421 2 19.5 5.41154 19.5 9.61989C19.5 12.082 18.3499 14.2714 16.5687 15.6633C16.309 15.8662 16.0358 16.0522 15.7507 16.2198V16.2857H8.24931V16.2198C7.96418 16.0522 7.691 15.8662 7.43134 15.6633C5.65009 14.2714 4.5 12.082 4.5 9.61989Z",
		fill: "currentColor"
	}), /* @__PURE__ */ jsx("path", {
		d: "M8.24931 17.7143V18.1894C8.24931 20.2939 9.92855 22 12 22C14.0715 22 15.7507 20.2939 15.7507 18.1894V17.7143H8.24931Z",
		fill: "currentColor"
	})] })
});
//#endregion
export { Bulb };
